import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    const categoryMap: Record<string, string> = {
      action: '动作片',
      comedy: '喜剧片',
      scifi: '科幻片',
      classic: '经典电影',
      romance: '爱情片',
      horror: '恐怖片',
      animation: '动画片',
      documentary: '纪录片',
    };
    items.push({ label: categoryMap[pathSegments[1]] || pathSegments[1], path: `/category/${pathSegments[1]}` });
  } else if (pathSegments[0] === 'movie' && pathSegments[1]) {
    items.push({ label: '电影详情' });
  } else if (pathSegments[0] === 'about') {
    items.push({ label: '关于我们' });
  }

  if (items.length === 1 && location.pathname !== '/') {
    return null;
  }

  return (
    <nav aria-label="面包屑导航" className="w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-24 pb-4">
      <ol className="flex items-center gap-2 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && (
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-foreground-600 text-xs"></i>
              </div>
            )}
            {item.path && index < items.length - 1 ? (
              <Link to={item.path} className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className={`${index === items.length - 1 ? 'text-foreground-200 font-medium' : 'text-foreground-600'}`}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}